import { component$, type PropsOf } from "@builder.io/qwik";
import { LuLock } from "@qwikest/icons/lucide";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";
import { cn } from "~/lib/cn";

export const PrivateIcon = component$<PropsOf<"svg">>((props) => (
  <Tooltip>
    <TooltipTrigger>
      <LuLock {...props} class={cn(`text-tertiary cursor-help`, props.class)} />
    </TooltipTrigger>
    <TooltipContent>
      This information is private. It will not be shown publicly.
    </TooltipContent>
  </Tooltip>
));
